export const createDictionaryFromList = <T, U = T>(
  list: T[],
  property: keyof T,
  getter: ((value: T) => U) | undefined = undefined
): Record<string, U> => {
  return list.reduce<Record<string, U>>((acc, element) => {
    acc[element[property] as string] = getter ? getter(element) : (element as unknown as U);
    return acc;
  }, {});
};

export const flattenArrayByKey = <T, K extends keyof T>(arr: T[], key: K): T[] => {
  const result: T[] = [];

  const flatten = (items: T[]) => {
    for (const item of items) {
      result.push(item);
      const target = item[key] as T[] | undefined;
      if (target?.length) {
        flatten(target);
      }
    }
  };

  flatten(arr);

  return result;
};

export const chunk = <T>(array: T[], size: number): T[][] => {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};
